<div class="results-container">
    <h2 class="page-title">Resumo Financeiro</h2>

    <div class="filter-bar">
        <div class="date-fields">
            <div class="date-field">
                <label for="since">Data inicial</label>
                <p-datepicker inputId="since" dateFormat="dd/mm/yy" [(ngModel)]="since" [readonlyInput]="true"
                    placeholder="Selecione a data inicial" />
            </div>

            <div class="date-field">
                <label for="until">Data final</label>
                <p-datepicker inputId="until" dateFormat="dd/mm/yy" [(ngModel)]="until" [readonlyInput]="true"
                    placeholder="Selecione a data final" />
            </div>

            <button class="btn-pesquisar" (click)="applyDateFilter()" [disabled]="isLoading">
                Filtrar
            </button>
        </div>

        <div class="action-buttons">
            <button class="btn-export" (click)="exportToCsv()" [disabled]="isLoading || !rows.length"
                title="Exportar dados para CSV">
                Exportar CSV
            </button>

            <button class="btn-refresh" (click)="clearFiltersAndRefresh()" [disabled]="isLoading" title="Atualizar">
                <i class="pi pi-refresh"></i>
            </button>
        </div>
    </div>

    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

    <section class="section-block">
        <div class="section-heading">
            <h3>Snapshot atual</h3>
            <span>Posição financeira da plataforma agora</span>
        </div>

        <div class="summary-grid">
            <article class="summary-card custody">
                <span class="summary-label">Moedas em custódia</span>
                <strong>R$ {{ snapshot.coin_custody_value | number: '1.2-2' }}</strong>
                <small>Exclui {{ snapshot.blacklisted_accounts_count || 0 }} usuários da blacklist financeira.</small>
            </article>

            <article class="summary-card liability">
                <span class="summary-label">Gemas sacáveis</span>
                <strong>R$ {{ snapshot.gem_withdrawable_value | number: '1.2-2' }}</strong>
                <small>Passivo potencial em diamantes/gemas, sem usuários blacklistados.</small>
            </article>

            <article class="summary-card warning">
                <span class="summary-label">Saques pendentes</span>
                <strong>R$ {{ snapshot.pending_cash_out_value | number: '1.2-2' }}</strong>
                <small>{{ snapshot.pending_cash_out_count || 0 }} solicitações em aberto.</small>
            </article>

            <article class="summary-card cash">
                <span class="summary-label">Caixa líquido estimado</span>
                <strong>R$ {{ snapshot.estimated_net_platform_cash | number: '1.2-2' }}</strong>
                <small>Compras de moedas aprovadas menos saques aprovados.</small>
            </article>
        </div>
    </section>

    <section class="section-block">
        <div class="section-heading">
            <h3>Período selecionado</h3>
            <span>Fluxo e receita entre {{ since | date: 'dd/MM/yyyy' }} e {{ until | date: 'dd/MM/yyyy' }}</span>
        </div>

        <div class="summary-grid period-grid">
            <article class="summary-card inflow">
                <span class="summary-label">Caixa recebido</span>
                <strong>R$ {{ summary.cash_in | number: '1.2-2' }}</strong>
                <small>Compra de moedas. Ainda representa custódia.</small>
            </article>

            <article class="summary-card revenue">
                <span class="summary-label">Receita realizada</span>
                <strong>R$ {{ summary.realized_revenue | number: '1.2-2' }}</strong>
                <small>Take rate, battle pass e skins/heróis.</small>
            </article>

            <article class="summary-card outflow">
                <span class="summary-label">Saques pagos</span>
                <strong>R$ {{ summary.cash_out | number: '1.2-2' }}</strong>
                <small>Saída de caixa por gemas sacadas.</small>
            </article>

            <article class="summary-card outflow">
                <span class="summary-label">Saídas missões extras</span>
                <strong>R$ {{ summary.extra_missions_outflow | number: '1.2-2' }}</strong>
                <small>Gemas pagas como recompensa de missões extras.</small>
            </article>

            <article class="summary-card result" [class.negative]="summary.net_realized_result < 0">
                <span class="summary-label">Resultado realizado</span>
                <strong>R$ {{ summary.net_realized_result | number: '1.2-2' }}</strong>
                <small>Receita realizada menos saques e recompensas de missões.</small>
            </article>

            <article class="summary-card capture">
                <span class="summary-label">Margem de captura</span>
                <strong>{{ summary.capture_margin * 100 | number: '1.1-1' }}%</strong>
                <small>Receita realizada sobre caixa recebido.</small>
            </article>
        </div>

        <div class="revenue-breakdown">
            <div class="breakdown-item">
                <span>Take Rate CS</span>
                <strong>R$ {{ summary.take_rate_cs | number: '1.2-2' }}</strong>
            </div>
            <div class="breakdown-item">
                <span>Take Rate LoL</span>
                <strong>R$ {{ summary.take_rate_lol | number: '1.2-2' }}</strong>
            </div>
            <div class="breakdown-item">
                <span>Battle Pass</span>
                <strong>R$ {{ summary.battle_pass_income | number: '1.2-2' }}</strong>
            </div>
            <div class="breakdown-item">
                <span>Skins/Heróis</span>
                <strong>R$ {{ summary.store_income | number: '1.2-2' }}</strong>
            </div>
            <div class="breakdown-item">
                <span>Missões extras</span>
                <strong>R$ {{ summary.extra_missions_income | number: '1.2-2' }}</strong>
            </div>
        </div>
    </section>

    <p-table [value]="rows" [loading]="isLoading" [paginator]="true" [rows]="30" [rowsPerPageOptions]="[15, 30]">
        <ng-template pTemplate="header">
            <tr>
                <th>Data</th>
                <th [pTooltip]="formulas.cash_in" tooltipPosition="top">Caixa Recebido (R$)</th>
                <th [pTooltip]="formulas.realized_revenue" tooltipPosition="top">Receita Realizada (R$)</th>
                <th [pTooltip]="formulas.net_realized_result" tooltipPosition="top">Resultado Realizado (R$)</th>
                <th [pTooltip]="formulas.take_rate_cs" tooltipPosition="top">Take Rate CS (R$)</th>
                <th [pTooltip]="formulas.take_rate_lol" tooltipPosition="top">Take Rate LoL (R$)</th>
                <th [pTooltip]="formulas.battle_pass_income" tooltipPosition="top">Passe (R$)</th>
                <th [pTooltip]="formulas.store_income" tooltipPosition="top">Loja (R$)</th>
                <th [pTooltip]="formulas.extra_missions_income" tooltipPosition="top">Missões extras (R$)</th>
                <th [pTooltip]="formulas.extra_missions_outflow" tooltipPosition="top">Saídas missões extras (R$)</th>
                <th [pTooltip]="formulas.cash_out" tooltipPosition="top">Saques Pagos (R$)</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
            <tr>
                <td>{{ row.date | date: 'dd/MM/yyyy' }}</td>
                <td>{{ (row.cash_in || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.realized_revenue || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.net_realized_result || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.take_rate_cs || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.take_rate_lol || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.battle_pass_income || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.store_income || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.extra_missions_income || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.extra_missions_outflow || 0) | number: '1.2-2' }}</td>
                <td>{{ (row.cash_out || 0) | number: '1.2-2' }}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="11" class="empty-message">Nenhum dado encontrado.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
